// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2aE-K","boxTitle":"Qualiphy_boxTitle__27h9O","box":"Qualiphy_box__3ixfV","toggleWrap":"Qualiphy_toggleWrap__2BRNo"};